module.exports = __webpack_public_path__ + "img/userB15.7d498c6f.jpg";